<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content>
  <form class="formAccount" #f="ngForm">
    <div class="container">
      <div class="row" *ngFor="let item of data.fields; let i=index">
        <div class="col-md-4 col-sm-12 col-12 text-right field-label">
          <label *ngIf="isValue(item.id)">{{item.label}}</label>
        </div>
        <div class="col-md-4 col-sm-4 col-7 no-padding">
          <mat-form-field class="form-full-width">
            <input matInput type="tel" name="{{item.paramId}}" [(ngModel)]="item.value" inputMask inputMaskType="{{item.validation}}" validatePercentage="{{item.validation}}" #valueInput="ngModel" [disabled]="loading">

            <mat-icon *ngIf="valueInput.errors && valueInput.dirty" class="mat-error" matSuffix>error</mat-icon>

            <mat-error>
              <span *ngIf="valueInput.errors?.required" [translate]="'painel-dashboard/field-required'">Field Required</span>
              <span *ngIf="!valueInput.errors?.required && valueInput.errors?.percentage" translate>validation-error/{{item.validation}}</span>
              <span *ngIf="!valueInput.errors?.required && !valueInput.errors?.percentage && valueInput.errors" [translate]="'painel-dashboard/invalid-value'">This value is not valid</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-1 col-sm-3 col-5 field-unity">
          <small>{{item.unity}}</small>
        </div>
        <div class="col-md-3 col-sm-4 col-5">
          <mat-form-field class="form-full-width">
            <input matInput type="text" name="dataSource-{{item.paramId}}" #dataSource="ngModel" [matAutocomplete]="auto" [(ngModel)]="item.dataSourceName" [disabled]="loading" placeholder="{{'painel-dashboard/data-source' | translate}}" [required]="valueInput.dirty">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of dataSourceField.option" [value]="option.name">
                <span>{{option.name}}</span>
              </mat-option>
            </mat-autocomplete>

            <mat-icon *ngIf="dataSource.errors && valueInput.dirty" class="mat-error" matSuffix>error</mat-icon>

            <mat-error>
              <span *ngIf="dataSource.errors?.required" [translate]="'painel-dashboard/field-required'">Field Required</span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

  </form>
</div>


<div mat-dialog-actions>
  <app-loading-bar *ngIf="loading"></app-loading-bar>
  <p *ngIf="loading" [translate]="'painel-dashboard/wait'">Wait a moment</p>

  <button *ngIf="!loading" type="button" class="btn-painel clear" (click)="onNoClick($event)" [translate]="'painel-dashboard/cancel'">Cancel</button>
  <button *ngIf="!loading" class="btn-painel branded" (click)="onSubmit()" [translate]="'painel-dashboard/save'" [disabled]="loading">Save</button>
</div>